<script>
    import { fade } from 'svelte/transition';
    import {link , push } from 'svelte-spa-router'
    import fetchData from '../api.js';
    import { systemUrl } from '../api.js';
    import { validateFields }  from '../base/validation.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte'; 
    import TopInfo from '../components/TopInfo.svelte'; 
    import Preloader from '../components/Preloader.svelte'; 

    let isLoading = true; 
    let print_url = '';
    

    export let params; 
    
    let likut = false;
    if (typeof params.likut!=='undefined') {
        likut = true;
    }

    
    let tracking_number = false;
    let orders = {};

    $: {
        
        if (shipment.destination.shipment_type==2) {          
            getStores(postData)            
        }
    }

    $: location_id = shipment.destination.datalogics_location;


    const getStores = async () => {

        let postData = {};
        postData.platform_id = shipment.destination.datalogics_platform_id;
        postData.action = 'crm_stores_by_platform';
        postData.token = $UserStore.data

        let response = await fetchData(postData);

        //console.log('response',response);

        if (response.data) {

            //stores = response.data; 

            const keyValueArray = Object.entries(response.data);

            // Sort the array by keys
            keyValueArray.sort((a, b) => a[0].localeCompare(b[0]));

            // Convert the sorted array back to an object
            stores = Object.fromEntries(keyValueArray);


            if (shipment.destination.datalogics_n_code!='') {
                for(let key in stores) {
                    stores[key].filter((store)=> {
                        console.log(store.n_code)
                        if (store.n_code == shipment.destination.datalogics_n_code) {
                            shipment.destination.datalogics_n_code_city = store.city
                        }
                    })
                }
            }

        }
    }    

    let stores = [];
    let settings = {};
    let general_settings = {};
    let shipping_methods = [];
    let locations = [];
    let selected_shipping_method = {}
    let items = {}
    


    let shipment = {
        shipment_id : '',
        order_name : '',
        platform_id : '',
        order_id : '',
        general_comments : '',
        reference : '',
        origin : {
            // fullname : '',
            // phone : '',
            // email : '',
            // city : '',
            // address : '',
            // house : '',
            // entrance : '',
            // apartment : '',
            // floor : '',
            // door : '',
            comments : ''
        },
        destination : {
            datalogics_fullname : '',
            datalogics_phone : '',
            datalogics_email : '',
            datalogics_city : '',
            datalogics_address : '',
            datalogics_house : '',
            datalogics_entrance : '',
            datalogics_apartment : '',
            datalogics_floor : '',
            datalogics_door : '',
            datalogics_shipment_type : "1",
            datalogics_shipment_select : "1",
            datalogics_govina_sum : '',
            datalogics_comments : '',
            datalogics_n_code : '',
            datalogics_n_code_city : '',
            datalogics_platform_id : '',
            datalogics_reference : '',
            datalogics_location : 0
            
        }
    }

    
    onMount(async() => {

        console.log('UserStore',$UserStore)

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }

        locations = $UserStore.settings?.shipping_settings?.datalogics_update_inventory_locations ?? []

        print_url = systemUrl + '/label?token=' + $UserStore.data + "&order_ids=";

        settings = $UserStore.settings.shipping_settings;
        general_settings = settings;

        if (settings.shipping_method && settings.shipping_method.length) {
            shipping_methods = settings.shipping_method;
            selected_shipping_method = shipping_methods[0]
        } else {
            shipping_methods = [];
        }  

        

        shipment.destination.datalogics_platform_id = selected_shipping_method.shipping_push_supplier; 
      
        
        if (params && params.shipments_ids) {

            
            let shipments_ids = params.shipments_ids.split(",");
            console.log(shipments_ids)
            await Promise.all(shipments_ids.map(async(order_id) => {

                let postData = {};   

                postData.action = 'crm_get_shipment';
                postData.token = $UserStore.data                
                postData.shipment_id = order_id
                if (likut==true){
                    postData.details = 1;
                }
                let response = await fetchData(postData);

                if (response.data) {

                    let shipping_data = response.data[0];

                    //console.log('shipping_data',shipping_data)

                    //console.log('shipment',shipment)

                    let order = JSON.parse(JSON.stringify(shipment));

                    order.shipment_id = shipping_data.shipment_id;
                    order.order_name = shipping_data.order_name;
                    order.order_id = shipping_data.order_id;
                    //shipment.platform_id = shipping_data.platform_id

                    order.destination.datalogics_fullname = shipping_data.client_name;
                    order.destination.datalogics_phone = shipping_data.client_phone;
                    order.destination.datalogics_email = shipping_data.client_email;
                    order.destination.datalogics_city = shipping_data.client_city;
                    order.destination.datalogics_address = shipping_data.client_street;
                    order.destination.datalogics_house = shipping_data.client_house;
                    order.destination.datalogics_entrance = shipping_data.shipping_entrance;
                    order.destination.datalogics_apartment = shipping_data.shipping_apartment;
                    order.destination.datalogics_floor = shipping_data.shipping_floor;
                    order.destination.datalogics_door = shipping_data.shipping_door;
                    order.destination.datalogics_shipment_type = "1";
                    order.destination.datalogics_shipment_select = "1";
                    order.destination.datalogics_govina_sum = '';
                    order.destination.datalogics_comments = shipping_data.comments;
                    order.destination.datalogics_n_code = shipping_data.ncode;
                    order.destination.datalogics_n_code_city = '';
                    order.destination.datalogics_location = 0;
                    order.destination.datalogics_reference = shipping_data.order_name;

                    if (order.destination.datalogics_n_code!='') {
                        order.destination.datalogics_shipment_select = "2";
                    }

                    if (shipping_data.items) {

                        shipping_data.items.filter((item)=>{

                            var sku = item.sku;
                            var name = item.name;

                            if (items[sku]) {
                                items[sku].quantity += parseInt(item.quantity);
                            } else {
                                items[sku] = {
                                    order_id : order.order_id,
                                    name : name,
                                    sku: sku,
                                    quantity: parseInt(item.quantity),
                                    quantity_scanned: 0,
                                    scanned_status: 0
                                };
                            }
                        });

                    }

                    orders[order_id] = order;

                }


            }));
            

        }

        getStores()

        isLoading = false; 
        
        
    })

    async function processOrdersSequentially() {

        isLoading = true;

        const sortedOrderKeys = Object.keys(orders).sort((a, b) => a - b); 

        console.log('sortedOrderKeys',sortedOrderKeys,orders)


        for (let order_id of sortedOrderKeys) {
            if (!validateFields(orders[order_id].destination)) {
                alert('יש למלא את כל השדות חובה');
                continue;
            }

            let postData = {};
            postData.action = 'crm_create_shipment';
            postData.token = $UserStore.data;
            postData.order_id = order_id;

            orders[order_id].destination.datalogics_platform_id = shipment.destination.datalogics_platform_id; 
            orders[order_id].destination.datalogics_location = shipment.destination.datalogics_location;
            postData.data = orders[order_id].destination;


            try {
                let response = await fetchData(postData);
                console.log('handleSubmit', response);

                // If the response contains data, update the order with the shipment_id
                if (response.data) {
                    orders[order_id].shipment_id = response.data.shipment_id;
                }
            } catch (error) {
                console.error(`Error processing order ${order_id}:`, error);
            }
        }

        isLoading = false;

    }

    const handleSubmit =  async () => {
        await processOrdersSequentially();
    }

    const BulkPrint = () => {

        const orderIdsWithShipment = [];
        Object.keys(orders).forEach(orderId => {
            if (orders[orderId].shipment_id) {
                orderIdsWithShipment.push(orderId);
            }
        });

        let link = print_url + orderIdsWithShipment.join(",");

        if (shippingo=="1") {
            link += "&shippingo=1";
        }
        
        window.open(link, '_blank');

    }


    function handleItemsScannCount(barcodeKey) {


        items[barcodeKey].quantity_scanned++;
        if (items[barcodeKey].quantity_scanned>=items[barcodeKey].quantity) {
            items[barcodeKey].scanned_status = 2;
            items[barcodeKey].quantity_scanned = items[barcodeKey].quantity;
        } else {
            items[barcodeKey].scanned_status = 1;
        }

        items = {...items}

    }

    async function printLikut(){
            
        let shipments_ids = params.shipments_ids.split(",");

        let postData = {};
        postData.action = 'crm_print_orders_items';
        postData.token = $UserStore.data;
        postData.get = 1;
        postData.order_id = shipments_ids;

        let itemsURL = systemUrl + 'crm_print_orders_items?token=' + $UserStore.data + '&orders_id='+shipments_ids;
        window.open(itemsURL, '_blank');

        // try {
        //     let response = await fetchData(postData);
        //     if (response.data) {
                
        //     }
        // } catch (error) {
        //     console.error(`Error processing order ${order_id}:`, error);
        // }

    }

    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment">            
            <h1 class="text-[20px] font-bold">
                {#if shipment.order_id}
                    {$_('shipment.order_name')}: {shipment.order_name} {#if shipment.order_name!=shipment.order_id}({shipment.order_id}){/if}
                {:else}
                    {$_('shipment.shipment_name')}
                {/if}
            </h1>  
            {#if !locations[location_id]}
                <div>
                    {$_('shipment.locations_msg')}
                    <a class="link" use:link href="/locations">{$_('shipment.edit_locations')}</a>
                </div>
            {:else}
                {#if shipping_methods.length>1}
                <div class="shipping_companies">
                    <label>{$_('companies.shipping_company')}</label>
                    <select bind:value={shipment.destination.datalogics_platform_id}>
                    {#each shipping_methods as method}
                        <option value="{method.shipping_push_supplier}">{platforms[+method.shipping_push_supplier].name}</option>
                    {/each}
                    </select>
                </div>      
                {/if}
                {#if (Object.keys(items).length && ((settings.enable_scanning_products && settings.enable_scanning_products=="1") || (general_settings.enable_scanning_products && general_settings.enable_scanning_products=="1")))}
                <div class="shipment-items">
                    <div class="shipment_header flex justify-between">
                        <div><i class="fa-solid fa-barcode"></i> {$_('items.items')}</div>
                        {#if likut}
                        <div>
                            <div on:click={()=>printLikut()} class="bg-color text-white text-[14px] rounded-[15px] p-1 px-3 cursor-pointer">{$_('orders.print_likut_items')}</div>
                        </div>      
                        {/if}              
                    </div> 
                    <div class="shipment-items-box">
                        <div class="shipment-items-line shipment-items-line-head">
                            <div>{$_('items.sku')}</div>
                            <div>{$_('items.name')}</div>
                            <div>{$_('items.qty')}</div>
                            <div>{$_('items.qty_scanned')}</div>
                            <div>{$_('items.scanned_status')}</div>
                        </div>
                        {#each Object.keys(items) as item,key}
                        <div class="shipment-items-line">
                            <div>
                                {items[item].sku}
                            </div>
                            <div>{items[item].name}</div>
                            <div><div class="qty">{items[item].quantity}</div></div>
                            <div><div class="qty qty-scanned">{items[item].quantity_scanned}</div></div>
                            <div>
                                <div class="badge badge{items[item].scanned_status}" on:click={()=> { handleItemsScannCount(items[item].sku) } }>
                                {#if items[item].scanned_status==0}
                                    {$_('items.not_scanned')}
                                {:else if items[item].scanned_status==1}
                                    {$_('items.partial_scanned')}
                                {:else}
                                    {$_('items.scanned')}
                                {/if}
                                </div>
                            </div>
                        </div>
                        {/each}
                    </div>
                </div>
                {/if}
                {#if !likut}
                <div class="shipment-flex">
                    <div class="shipment_origin">
                        <div class="shipment_header">
                            <i class="fa-regular fa-map"></i> {$_('shipment.origin')}
                        </div>   
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.location_name')} <a class="link" use:link href="/locations">{$_('shipment.edit_locations')}</a></label>      
                                <select bind:value={shipment.destination.datalogics_location}>
                                {#each locations as location,index}
                                    {#if location.enabled}
                                    <option value="{index}">{location.name} - {location.street} {location.house} , {location.city} </option>
                                    {/if}
                                {/each}
                                </select>
                            </div>
                        </div>
                        <div class="input_box">      
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.name')}</label>
                                <input type="text" bind:value={locations[location_id].name} disabled>
                            </div>
                        </div>
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.phone')}</label>
                                <input type="text" bind:value={locations[location_id].phone} disabled>
                            </div>             
                            <div class="input_con">
                                <label>{$_('shipment.email')}</label>
                                <input type="text" bind:value={locations[location_id].email} disabled>
                            </div>
                        </div>
                        <div class="input_box">
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.city')}</label>
                                <input type="text" bind:value={locations[location_id].city} disabled>
                            </div>
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.street')}</label>
                                <input type="text" bind:value={locations[location_id].street} disabled>
                            </div>
                            <div class="input_con">
                                <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.house')}</label>
                                <input type="text" bind:value={locations[location_id].house} disabled>
                            </div>
                        </div>
                        <!-- 
                        <div class="input_box">
                            
                            <div class="input_con">
                                <label>{$_('shipment.entrance')}</label>
                                <input type="text" bind:value={shipment.origin.entrace}>
                            </div>
                            <div class="input_con">
                                <label>{$_('shipment.floor')}</label>
                                <input type="text" bind:value={shipment.origin.floor}>
                            </div>
                            <div class="input_con">
                                <label>{$_('shipment.apartment')}</label>
                                <input type="text" bind:value={shipment.origin.apartment}>
                            </div>
                        </div>
                         -->
                        <!-- <div class="input_box">
                            <div class="input_con">
                                <label>{$_('shipment.origin_comments')}</label>
                                <input type="text" bind:value={shipment.origin.comments}>
                            </div>                    
                        </div> -->
                    </div>
                    <div class="shipment_destination">
                        <div class="shipment_header">
                            <i class="fa-solid fa-location-dot"></i> {$_('shipment.destination')}
                        </div> 
                    {#each Object.keys(orders) as order_key,index } 
                        {#if !orders[order_key].open}

                            {#if orders[order_key].shipment_id}
                                <div class="shipment_notification">
                                    {orders[order_key].order_name} {$_('shipment.your_tracking_number_created')} 
                                    <a href="{print_url}{orders[order_key].order_id}" target="_blank">
                                        <i class="fa-solid fa-print red-color"></i> 
                                        <strong>{orders[order_key].shipment_id}</strong>
                                        {$_('shipment.print_click_here')} 
                                    </a>
                                </div>            
                            {:else}
                                <div class="shipment_destination_closed" on:click={()=> { orders[order_key].open = true } }>
                                    <div>
                                    {orders[order_key].order_name} 
                                    {orders[order_key].destination.datalogics_fullname}
                                    {orders[order_key].destination.datalogics_city}
                                    {orders[order_key].destination.datalogics_address}
                                    </div>
                                    <div>
                                        <i class="fa-solid fa-chevron-down"></i>
                                    </div>
                                </div>
                            {/if}
                        {:else}
                        <div class="shipment_destination_key">
                            <div class="shipment_destination_closed shipment_destination_open" on:click={()=> { orders[order_key].open = false } }>
                                <div>
                                {orders[order_key].order_name} 
                                </div>
                                <div>
                                    <i class="fa-solid fa-chevron-up"></i>
                                </div>
                            </div>
                            <div class="input_box">
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.shipping_type')}</label>      
                                    <select bind:value={orders[order_key].destination.datalogics_shipment_type}>
                                        <option value="1"> {$_('shipment.delivery')}</option>
                                        <option value="2"> {$_('shipment.double_govina')}</option>
                                        <option value="3"> {$_('shipment.pickup')}</option>
                                    </select>
                                </div>
                                {#if orders[order_key].destination.datalogics_shipment_type=="2"}
                                <div class="input_con">
                                    <label>{$_('shipment.govina_sum')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_govina_sum}>
                                </div>
                                {/if}
                            </div>
                            <div class="input_box">      
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.name')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_fullname} class:input_empty_error={orders[order_key].destination.datalogics_fullname === ''}>
                                </div>
                            </div>
                            <div class="input_box">
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.phone')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_phone} class:input_empty_error={orders[order_key].destination.datalogics_phone === ''}>
                                </div>             
                                <div class="input_con">
                                    <label>{$_('shipment.email')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_email}>
                                </div>
                            </div>
                            {#if Object.keys(stores).length && platforms[shipping_push_supplier] && platforms[shipping_push_supplier].pickup && platforms[shipping_push_supplier].pickup=="1"}
                            <div class="input_box">
                                <div class="input_con radio">
                                    <input id="shipment_type1" type="radio" name="shipment_type" bind:group={orders[order_key].destination.datalogics_shipment_select} value="1">
                                    <label for="shipment_type1"><i class="fa-solid fa-asterisk"></i> {$_('shipment.specific_location')}</label>
                                </div>
                                <div class="input_con radio">
                                    <input id="shipment_type2" type="radio" name="shipment_type" bind:group={orders[order_key].destination.datalogics_shipment_select}  value="2">
                                    <label for="shipment_type2"><i class="fa-solid fa-asterisk"></i> {$_('shipment.pudo')}</label>
                                </div>
                            </div>
                            {/if}
                            {#if orders[order_key].destination.datalogics_shipment_select==1}
                            <div class="input_box">
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.city')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_city} class:input_empty_error={orders[order_key].destination.datalogics_city === ''}>
                                </div>
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.street')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_address} class:input_empty_error={orders[order_key].destination.datalogics_address === ''}>
                                </div>
                            </div>
                            <div class="input_box">
                                <div class="input_con">
                                    <label>{$_('shipment.house')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_house}>
                                </div>
                                <div class="input_con">
                                    <label>{$_('shipment.entrance')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_entrace}>
                                </div>
                                <div class="input_con">
                                    <label>{$_('shipment.floor')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_floor}>
                                </div>
                                <div class="input_con">
                                    <label>{$_('shipment.apartment')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_apartment}>
                                </div>
                            </div>
                            {:else}
                            <div class="input_box">
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.city')}</label>
                                    <select bind:value={orders[order_key].destination.datalogics_n_code_city}>
                                        <option value="">יש לבחור עיר</option>
                                        {#each Object.keys(stores) as item,index}
                                            <option value="{item}">{item}</option>
                                        {/each}
                                    </select>
                                </div>
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i> {$_('shipment.podu_location')}</label>
                                    <select bind:value={orders[order_key].destination.datalogics_n_code}>
                                        <option value="">יש לבחור ממס</option>
                                        {#if orders[order_key].destination.datalogics_n_code_city!='' && stores[orders[order_key].destination.datalogics_n_code_city]}
                                            {#each stores[orders[order_key].destination.datalogics_n_code_city] as item,index}
                                                <option value="{item.n_code}">{item.name} - {item.street} {item.house}</option>
                                            {/each}
                                        {/if}
                                    </select>
                                </div>
                            </div>
                            <div class="input_box">
                                <div class="input_con">
                                    <label>{$_('shipment.general_comments')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_comments}>
                                </div>
                                <div class="input_con">
                                    <label>{$_('shipment.reference')}</label>
                                    <input type="text" bind:value={orders[order_key].destination.datalogics_reference}>
                                </div>
                            </div>
                            {/if}                            
                        </div>                        
                        {/if}
                    {/each}   
                    </div>         
                </div>      
                <div class="orders-bulk-con">
                    <div class="button" on:click={()=>{ handleSubmit(); }}>{$_('shipment.create_shipment')}</div>
                    <div class="button" on:click={()=> BulkPrint() }>{$_('shipment.print')}</div>
                </div>
                {/if} 
            {/if}
        </div>
        
    </div>
</div>

<style>   

    .shipment-items-box {
        display: table;
        width:100%;
        font-size: 14px;;
    }
    .shipment-items-line-head {
        font-weight: bold;
    }
    .shipment-items-line {
        display:table-row;
        width: 100%;        
    }
    .shipment-items-line > div {
        display:table-cell;
        border-bottom:1px solid rgb(171 171 171);  
        border-bottom:1px solid rgb(226, 226, 226);  
        padding:4px;
        border-collapse: collapse;;
        text-align: center;
    }

    .qty {
        background-color: #5b5b5b;
        color: white;
        border-radius: 5px;;
        padding:5px;
        display: inline-block;
        width: 20px;;
        text-align: center;
    }
    .qty-scanned {
        background-color: #262626;
    }
    .badge {
        width: 90px;
        background-color: #60a325;
        color: white;
        border-radius: 5px;;
        padding:5px 10px;
        display: inline-block;
    }
    .badge0 {
        background-color: var(--theme-one-color);
    }
    .badge1 {
        background-color: #234fe0;
    }

    
    .shipment-flex {
        text-align: center;
        display: flex;  
    }
    
    .shipment-flex > div {
        flex:1;
        padding:10px;
    }
    
    .shipment_header {
        color: var(--theme-one-color);
        padding: 10px 0;
        margin-bottom: 20px;
        /* border-radius: 10px; */
        font-size: 22px;
        text-align: right;
        border-bottom: 1px solid rgb(171 171 171);
    }
    
    
    .shipment_header i {
        color: rgb(73 73 73)
    }

    .shipment_notification {
        padding:10px;
        border:1px solid green;
        background-color: rgb(228, 255, 228);
        border-radius:10px;
        margin-bottom: 10px;
        font-size: 14px;;
    }

    .shipment_destination {
        flex-direction:column;
        display:flex;
    }

    .shipment_destination_closed {
        margin-top:24px;
        text-align: right;
        background-color: var(--theme-one-color);
        color:#fff;
        border:0;
        border-radius: 7px;;
        padding:10px;
        font-size: 14px;;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
    
    }
    .shipment_destination_open {
        background-color: var(--theme-one-color);
        border:0;
        color:#fff;
    }

    @media screen and (max-width:600px) {
        .shipment-flex {
            text-align: center;
            display: flex;  
            flex-direction: column;
        }
    }

</style>